module.exports = __webpack_public_path__ + "img/收起.4720027a.svg";